import React, { useState } from 'react';
import { bool, func, string } from 'prop-types';
import { Checkbox } from '@material-ui/core';

const CheckboxInput = ({ checked, onChange, id }) => {
  const [check, setCheck] = useState(checked);

  return (
    <Checkbox
      checked={check}
      onChange={() => onChange(check, setCheck, id)}
    />
  );
};

CheckboxInput.propTypes = {
  id: string,
  checked: bool,
  onChange: func,
};

export default CheckboxInput;
